import { Button } from '@givebutter/primitives/button';
import { faChevronLeft, faGavel, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    CreateCampaignDialogForm,
    useCreateCampaignDialogContext,
} from 'components/create-campaign-dialog/CreateCampaignDialogContext';
import * as FeatureCheckboxItem from 'components/create-campaign-dialog/FeatureCheckboxItem';
import { useGivebutterFormContext } from 'components/form';
import { posthogEvents } from 'constants/posthog-events';
import { usePosthog } from 'customHooks/usePosthog';

const CampaignAddFeaturesSelection = () => {
    const { setStep } = useCreateCampaignDialogContext();
    const { pushEvent } = usePosthog();

    const { watch } = useGivebutterFormContext<CreateCampaignDialogForm>();

    const [enableTeamFundraising, enableAuction] = watch([
        'enableTeamFundraising',
        'enableAuction',
    ]);

    const anySelected = enableTeamFundraising || enableAuction;

    return (
        <div className="flex h-full w-full items-center justify-center">
            <div className="flex w-full flex-col gap-6 px-4 sm:w-1/2 sm:px-0">
                <h3 className={'text-xl font-medium'}>Add features to your campaign</h3>
                <div className="flex flex-col gap-2">
                    <FeatureCheckboxItem.Root
                        value="enableTeamFundraising"
                        posthogEventDispatch={() =>
                            pushEvent(posthogEvents.CAMPAIGN_CREATE_ADDONS_SELECTED, {
                                type: 'Peer 2 Peer',
                            })
                        }
                    >
                        <FeatureCheckboxItem.Icon icon={faUsers} />
                        <div>
                            <FeatureCheckboxItem.Title>Peer-to-peer</FeatureCheckboxItem.Title>
                            <FeatureCheckboxItem.Description>
                                Expand your reach by engaging your supporters as individual and/or
                                team fundraisers.
                            </FeatureCheckboxItem.Description>
                        </div>
                    </FeatureCheckboxItem.Root>

                    <FeatureCheckboxItem.Root
                        value="enableAuction"
                        posthogEventDispatch={() =>
                            pushEvent(posthogEvents.CAMPAIGN_CREATE_ADDONS_SELECTED, {
                                type: 'Auction',
                            })
                        }
                    >
                        <FeatureCheckboxItem.Icon icon={faGavel} />
                        <div>
                            <FeatureCheckboxItem.Title>Auction</FeatureCheckboxItem.Title>
                            <FeatureCheckboxItem.Description>
                                Host an online, hybrid, or in-person auction that makes it seamless
                                and fun for you and your supporters.
                            </FeatureCheckboxItem.Description>
                        </div>
                    </FeatureCheckboxItem.Root>
                </div>
                <div className="flex flex-col-reverse justify-between gap-2 sm:flex-row sm:gap-0">
                    <Button
                        variant="transparent"
                        color="neutral"
                        className="font-medium text-gray-600"
                        onClick={() => setStep('start')}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} className="hidden sm:inline-block" />
                        Back
                    </Button>
                    <Button
                        variant={anySelected ? 'solid' : 'outline'}
                        color={anySelected ? 'primary' : 'neutral'}
                        onClick={() => {
                            setStep('newTitle');
                            pushEvent(posthogEvents.CAMPAIGN_CREATE_ADDONS_SUBMITTED, {
                                enableTeamFundraising,
                                enableAuction,
                            });
                        }}
                    >
                        {anySelected ? 'Continue' : 'Maybe later'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export { CampaignAddFeaturesSelection };
